import React, { useEffect, useRef, useState } from 'react';
import { getFieldValue } from '../../../contentful/mappers';
import './Grid.css';

function Grid({ data }) {
  const [visibleItems, setVisibleItems] = useState(new Set());
  const itemRefs = useRef([]);

  const items = data ? (getFieldValue(data, 'items') || []) : [];

  useEffect(() => {
    if (!data || items.length === 0) return;

    const observers = [];

    itemRefs.current.forEach((ref, index) => {
      if (!ref) return;

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              setVisibleItems((prev) => new Set([...prev, index]));
            }
          });
        },
        {
          threshold: 0.1,
          rootMargin: '0px 0px -50px 0px',
        }
      );

      observer.observe(ref);
      observers.push(observer);
    });

    return () => {
      observers.forEach((observer) => observer.disconnect());
    };
  }, [data, items.length]);

  if (!data) return null;

  const headline = getFieldValue(data, 'headline');
  const bgTheme = getFieldValue(data, 'bgTheme') || 'light';

  const sectionClass = `grid-section grid-section-${bgTheme}`;

  return (
    <section className={sectionClass}>
      <div className="container">
        {headline && <h1 className="section-headline">{headline}</h1>}
        <div className="grid">
          {items.map((item, index) => {
            const title = getFieldValue(item, 'title');
            const description = getFieldValue(item, 'description');
            const isVisible = visibleItems.has(index);
            
            return (
              <div
                key={item.sys?.id || index}
                ref={(el) => (itemRefs.current[index] = el)}
                className={`grid-item ${isVisible ? 'grid-item-visible' : ''}`}
                style={isVisible ? { animationDelay: `${index * 0.1}s` } : {}}
              >
                <h3 className="grid-item-title">{title}</h3>
                {description && <p className="grid-item-description">{description}</p>}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default Grid;

